import React, { useContext, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { CButton, CCard, CCol, CRow } from '@coreui/react'
import Video1 from 'src/assets/Content-Icons/PNGs/video-icon.png'
import Audio1 from 'src/assets/Content-Icons/PNGs/audio-icon.png'
import Singlepart from 'src/assets/Content-Icons/PNGs/single-video-icon.png'
import MultiPart from 'src/assets/Content-Icons/PNGs/multi-part-parent-icon.png'
import MultiChild from 'src/assets/Content-Icons/PNGs/multi-part-child-icon.png'
import Live from 'src/assets/Content-Icons/PNGs/live-stream-icon.png'
import VodAsLive from 'src/assets/Content-Icons/PNGs/vod-as-live-icon.png'
import Lecture from 'src/assets/Content-Icons/PNGs/lecture-icon.png'
import Playlist from 'src/assets/Content-Icons/PNGs/playlist-icon.png'
import Webinar from 'src/assets/Content-Icons/PNGs/webinar-icon.png'
import Events from 'src/assets/Content-Icons/PNGs/events-icon.png'
import Meetings from 'src/assets/Content-Icons/PNGs/meetings-icon.png'
import Iptv from 'src/assets/Content-Icons/PNGs/ip-tv-icon.png'
import Townhall from 'src/assets/Content-Icons/PNGs/townhall-icon.png'
import BackArrowIcon from 'src/assets/back-btn-arrow-cms.svg'
import './content.scss'
import '../../../scss/style.scss'
import { checkModuleAllowed, isEmpty, raiseToast } from '../../utils/helper'
import { AppContext } from 'src/views/context/app'

const AssetType = (props) => {
  const { toggleValue, isEdit, details } = props
  const { accountObj } = useContext(AppContext)
  const dispatch = useDispatch()
  const [toggle, setToggle] = useState('asset')
  const [assetType, setAssetType] = useState('')
  const [videoType, setVideoType] = useState('')
  // const [audioType, setAudioType] = useState('')
  const isIPTVAllowed = checkModuleAllowed('iptv_module', accountObj.module_permissions)

  useEffect(() => {
    if (isEdit && !isEmpty(details)) {
      setAssetType(details['asset_type'])
      dispatch({
        type: 'ASSET',
        payload: {
          assetType: details['asset_type'],
          videoType: details?.video_type ? details['video_type'] : '',
        },
      })
      if (details?.video_type) {
        setVideoType(details['video_type'])
        setToggle(details['video_type'])
        toggleValue(2)
      }
    }
  }, [isEdit, details])

  const handleAsset = (type) => {
    if (type === 'VIDEO') {
      setAssetType(type)
      setToggle(type)
    } else {
      alert('Coming Soon')
    }
  }
  const handleVideoType = (type) => {
    if (type === 'IPTV' && !isIPTVAllowed) {
      raiseToast('error', "You don't have IPTV included in your Plan!")
      return
    }
    setVideoType(type)
    dispatch({ type: 'ASSET', payload: { assetType, videoType: type } })
    if (type !== 'IPTV') {
      toggleValue(2)
    }
  }

  const handleIPTVType = (type) => {
    dispatch({ type: 'IPTV_ASSET', payload: { iptvType: type } })
    toggleValue(2)
  }

  const imgSize = {
    height: '5.4vw',
    width: '5.4vw',
  }
  return (
    <>
      {toggle === 'asset' ? (
        <CCard style={{ textAlign: 'center' }}>
          <div className="mb-3" style={{ margin: '5rem 2rem 0' }}>
            <h3 style={{ fontSize: '1.5vw' }}>Select your Asset type</h3>
            <div
              className="mb-5 d-flex justify-content-center"
              style={{ marginTop: '3.5rem', gap: '0 6.5rem' }}
            >
              <div
                className=" d-flex flex-column justify-content-center align-items-center p-3 rounded-3 hover-semibold hover-shadow"
                role="button"
                onClick={() => handleAsset('VIDEO')}
              >
                <img
                  src={Video1}
                  alt=""
                  style={{
                    ...imgSize,
                  }}
                />
                <span style={{ fontSize: '19px', fontWeight: 'inherit' }} className="mt-3">
                  Video
                </span>
              </div>
              <div
                className=" d-flex flex-column justify-content-center align-items-center p-3 rounded-3 hover-semibold hover-shadow"
                role="button"
                onClick={() => handleAsset('AUDIO')}
              >
                <img
                  src={Audio1}
                  alt=""
                  style={{
                    ...imgSize,
                  }}
                />
                <span style={{ fontSize: '19px', fontWeight: 'inherit' }} className="mt-3">
                  Audio
                </span>
              </div>
            </div>
            <div className="px-lg-5" style={{ marginTop: '8.42vw', marginBottom: '7.36vw' }}>
              <p
                className="mt-4 2xl:text-xl xl:text-lg"
                style={{ padding: '0 5em', textAlign: 'left', fontSize: '1.1vw' }}
              >
                Asset Manager allows you to upload your asset on the platform. It provides you the
                options to set the details, category, pricing and advance settings of your asset.
              </p>
            </div>
          </div>
        </CCard>
      ) : (
        <>
          {assetType === 'VIDEO' && videoType !== 'IPTV' && (
            <CCard style={{ textAlign: 'center' }}>
              <div className="mb-3 px-lg-5" style={{ margin: '5rem 1rem 0' }}>
                <h3 style={{ fontSize: '1.5vw' }}>Select your Video type</h3>
                <div className="mt-5 mb-5 d-flex justify-content-between">
                  <div
                    className=" d-flex flex-column justify-content-start align-items-center p-3 rounded-3 hover-semibold hover-shadow"
                    role="button"
                    style={{ width: '9rem' }}
                    onClick={() => handleVideoType('SPV')}
                  >
                    <img
                      src={Singlepart}
                      alt=""
                      style={{
                        ...imgSize,
                      }}
                    />
                    <span
                      style={{ fontSize: '.94vw', fontWeight: 'inherit' }}
                      className="mt-3 font-semibold"
                    >
                      Single Part Video
                    </span>
                  </div>
                  <div
                    className=" d-flex flex-column justify-content-start align-items-center p-3 rounded-3 hover-semibold hover-shadow"
                    role="button"
                    style={{ width: '9rem' }}
                    onClick={() => handleVideoType('MPVP')}
                  >
                    <img
                      src={MultiPart}
                      alt=""
                      style={{
                        ...imgSize,
                      }}
                    />
                    <span
                      style={{ fontSize: '.94vw', fontWeight: 'inherit' }}
                      className="mt-3 font-semibold"
                    >
                      Multi-Part Parent Video
                    </span>
                  </div>
                  <div
                    className=" d-flex flex-column justify-content-start align-items-center p-3 rounded-3 hover-semibold hover-shadow"
                    role="button"
                    style={{ width: '9rem' }}
                    onClick={() => handleVideoType('MPVC')}
                  >
                    <img
                      src={MultiChild}
                      alt=""
                      style={{
                        ...imgSize,
                      }}
                    />
                    <span
                      style={{ fontSize: '.94vw', fontWeight: 'inherit' }}
                      className="mt-3 font-semibold"
                    >
                      Multi-Part Child Video
                    </span>
                  </div>
                  <div
                    className=" d-flex flex-column justify-content-start align-items-center p-3 rounded-3 hover-semibold hover-shadow"
                    role="button"
                    style={{ width: '9rem' }}
                    onClick={() => handleVideoType('LIVE')}
                  >
                    <img
                      src={Live}
                      alt=""
                      style={{
                        ...imgSize,
                      }}
                    />
                    <span
                      style={{ fontSize: '.94vw', fontWeight: 'inherit' }}
                      className="mt-3 font-semibold"
                    >
                      Live Streaming
                    </span>
                  </div>
                  <div
                    className=" d-flex flex-column justify-content-start align-items-center p-3 rounded-3 hover-semibold hover-shadow"
                    role="button"
                    style={{ width: '9rem' }}
                    onClick={() => handleVideoType('VOD_LIVE')}
                  >
                    <img
                      src={VodAsLive}
                      alt=""
                      style={{
                        ...imgSize,
                      }}
                    />
                    <span
                      style={{ fontSize: '.94vw', fontWeight: 'inherit' }}
                      className="mt-3 font-semibold"
                    >
                      VOD as Live
                    </span>
                  </div>
                  <div
                    className=" d-flex flex-column justify-content-start align-items-center p-3 rounded-3 hover-semibold hover-shadow"
                    role="button"
                    style={{ width: '9rem' }}
                    onClick={() => handleVideoType('IPTV')}
                  >
                    <img
                      src={Iptv}
                      alt=""
                      style={{
                        ...imgSize,
                      }}
                    />
                    <span
                      style={{ fontSize: '.94vw', fontWeight: 'inherit' }}
                      className="mt-3 font-semibold"
                    >
                      IP TV
                    </span>
                  </div>
                </div>
                <div className="mb-5 d-flex justify-content-between" style={{ margin: '3rem 0 0' }}>
                  <div
                    className=" d-flex flex-column justify-content-start align-items-center p-3 rounded-3 hover-semibold hover-shadow"
                    role="button"
                    style={{ width: '9rem' }}
                    onClick={() => handleVideoType('PLAYLIST')}
                  >
                    <img
                      src={Playlist}
                      alt=""
                      style={{
                        ...imgSize,
                      }}
                    />
                    <span
                      style={{ fontSize: '.94vw', fontWeight: 'inherit' }}
                      className="mt-3 font-semibold"
                    >
                      Playlist
                    </span>
                  </div>
                  <div
                    className=" d-flex flex-column justify-content-start align-items-center p-3 rounded-3 hover-semibold hover-shadow"
                    role="button"
                    style={{ width: '9rem' }}
                    // onClick={() => handleVideoType('MPVP')}
                  >
                    <img
                      src={Webinar}
                      alt=""
                      style={{
                        ...imgSize,
                      }}
                    />
                    <span
                      style={{ fontSize: '.94vw', fontWeight: 'inherit' }}
                      className="mt-3 font-semibold"
                    >
                      Webinar
                    </span>
                  </div>
                  <div
                    className=" d-flex flex-column justify-content-start align-items-center p-3 rounded-3 hover-semibold hover-shadow"
                    role="button"
                    style={{ width: '9.5rem' }}
                    // onClick={() => handleVideoType('MPVC')}
                  >
                    <img
                      src={Events}
                      alt=""
                      style={{
                        ...imgSize,
                      }}
                    />
                    <span
                      style={{ fontSize: '.94vw', fontWeight: 'inherit' }}
                      className="mt-3 font-semibold"
                    >
                      Virtual Events
                    </span>
                  </div>
                  <div
                    className=" d-flex flex-column justify-content-start align-items-center p-3 rounded-3 hover-semibold hover-shadow"
                    role="button"
                    style={{ width: '9rem' }}
                    // onClick={() => handleVideoType('LIVE')}
                  >
                    <img
                      src={Meetings}
                      alt=""
                      style={{
                        ...imgSize,
                      }}
                    />
                    <span
                      style={{ fontSize: '.94vw', fontWeight: 'inherit' }}
                      className="mt-3 font-semibold"
                    >
                      Meetings
                    </span>
                  </div>
                  <div
                    className=" d-flex flex-column justify-content-start align-items-center p-3 rounded-3 hover-semibold hover-shadow"
                    role="button"
                    style={{ width: '9rem' }}
                    // onClick={() => handleVideoType('LIVE')}
                  >
                    <img
                      src={Lecture}
                      alt=""
                      style={{
                        ...imgSize,
                      }}
                    />
                    <span
                      style={{ fontSize: '.94vw', fontWeight: 'inherit' }}
                      className="mt-3 font-semibold"
                    >
                      Video Lecture
                    </span>
                  </div>

                  <div
                    className=" d-flex flex-column justify-content-start align-items-center p-3 rounded-3 hover-semibold hover-shadow"
                    role="button"
                    style={{ width: '9rem' }}
                    // onClick={() => handleVideoType('LIVE')}
                  >
                    <img
                      src={Townhall}
                      alt=""
                      style={{
                        ...imgSize,
                      }}
                    />
                    <span
                      style={{ fontSize: '.94vw', fontWeight: 'inherit' }}
                      className="mt-3 font-semibold"
                    >
                      Town Hall
                    </span>
                  </div>
                </div>
              </div>
              <CRow className="mb-3 justify-content-lg-end px-lg-5">
                <div className="d-flex justify-content-end px-lg-5">
                  <CButton
                    onClick={() => {
                      setToggle('asset')
                      setVideoType('')
                    }}
                    color="info"
                    className="text-white d-flex align-items-center gap-2"
                    style={{ backgroundColor: '#20211c' }}
                  >
                    <img src={BackArrowIcon} alt="" />
                    Back
                  </CButton>
                </div>
              </CRow>
            </CCard>
          )}
          {assetType === 'VIDEO' && videoType === 'IPTV' && (
            <CCard style={{ textAlign: 'center' }}>
              <div className="mb-3" style={{ margin: '5rem 2rem 0' }}>
                <h3 style={{ fontSize: '1.5vw' }}>Select Content type</h3>
                <div
                  className="mb-5 d-flex justify-content-center"
                  style={{ marginTop: '3.5rem', gap: '0 6.5rem' }}
                >
                  <div
                    className=" d-flex flex-column justify-content-center align-items-center p-3 rounded-3 hover-semibold hover-shadow"
                    role="button"
                    onClick={() => handleIPTVType('VOD')}
                  >
                    <img
                      src={Singlepart}
                      alt=""
                      style={{
                        ...imgSize,
                      }}
                    />
                    <span style={{ fontSize: '19px', fontWeight: 'inherit' }} className="mt-3">
                      VOD
                    </span>
                  </div>
                  <div
                    className=" d-flex flex-column justify-content-center align-items-center p-3 rounded-3 hover-semibold hover-shadow"
                    role="button"
                    onClick={() => handleIPTVType('LIVE')}
                  >
                    <img
                      src={Live}
                      alt=""
                      style={{
                        ...imgSize,
                      }}
                    />
                    <span style={{ fontSize: '19px', fontWeight: 'inherit' }} className="mt-3">
                      LIVE
                    </span>
                  </div>
                </div>
                <div className="px-lg-5" style={{ marginTop: '8.42vw', marginBottom: '7.36vw' }}>
                  <p
                    className="mt-4 2xl:text-xl xl:text-lg"
                    style={{ padding: '0 5em', textAlign: 'left', fontSize: '1.1vw' }}
                  >
                    Asset Manager allows you to upload your asset on the platform. It provides you
                    the options to set the details, category, pricing and advance settings of your
                    asset.
                  </p>
                </div>
              </div>
            </CCard>
          )}
        </>
      )}
    </>
  )
}

export default AssetType
